import React from "react";
import { Box, Typography } from "@mui/material";
import type { ReactNode } from "react";

type PreviewFieldProps = {
  label: string;
  value: ReactNode;
  disabled?: boolean;
};

export function PreviewField({ label, value, disabled }: PreviewFieldProps) {
  return (
    <Box
      sx={(theme) => ({
        ...(disabled && {
          backgroundColor: theme.palette.grey[100],
          borderRadius: 1,
          px: 1.5,
          py: 1,
        }),
      })}
    >
      <Typography
        variant="body2"
        component="div"
        sx={{ fontWeight: "bold", color: "common.black", fontSize: "1.5rem" }}
      >
        {label}
      </Typography>
      <Typography
        variant="body1"
        sx={{ color: "text.primary", fontSize: "1.6rem" }}
      >
        {value}
      </Typography>
    </Box>
  );
}
